import { combineReducers } from 'redux';
import { Map, Set } from 'immutable';
import {
  FETCH_TOOLS,
  FETCH_TOOLS_SUCCESS,
  ADD_TOOL,
  UPDATE_TOOL,
  DELETE_TOOL,
} from '../actions/tools';

const updateInSite = (state, site) => thunk => {
  return state.update(site, Map(), thunk);
};

const values = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_TOOLS_SUCCESS:
      return updateInSite(
        state,
        action.site
      )(t => t.set(action.diagnostic, Set(action.tools)));
    case ADD_TOOL:
      return updateInSite(
        state,
        action.site
      )(t => t.update(action.diagnostic, tools => tools.add(action.tool)));
    case UPDATE_TOOL:
      return updateInSite(
        state,
        action.site
      )(t =>
        t.update(action.diagnostic, tools =>
          tools.map(t => {
            if (t.id.toString() === action.tool.id.toString()) {
              return action.tool;
            }

            return t;
          })
        )
      );
    case DELETE_TOOL:
      return updateInSite(
        state,
        action.site
      )(t =>
        t.update(action.diagnostic, tools =>
          tools.filter(t => t.id.toString() !== action.tool.id.toString())
        )
      );
    default:
      return state;
  }
};

const isFetching = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_TOOLS:
      return updateInSite(
        state,
        action.site
      )(t => t.set(action.diagnostic, true));
    case FETCH_TOOLS_SUCCESS:
      return updateInSite(state, action.site)(t => t.delete(action.diagnostic));
    default:
      return state;
  }
};

const deleted = (state = Map(), action) => {
  switch (action.type) {
    case DELETE_TOOL:
      return updateInSite(
        state,
        action.site
      )(t =>
        t.update(action.diagnostic, [], deleted => [...deleted, action.tool])
      );
    default:
      return state;
  }
};

const tools = combineReducers({
  isFetching,
  values,
  deleted,
});

export default tools;

export const getIsFetching = (state, site) =>
  state.siteCase.tools.isFetching.get(site, Map());
export const getTools = (state, site) =>
  state.siteCase.tools.values.get(site, Map());

const getNewTools = (state, site, type) => {
  const all = getTools(state, site).get(type, Set());
  return all.filter(t => t.new).toArray();
};

const getUpdatedTools = (state, site, type) => {
  const all = getTools(state, site).get(type, Set());
  const updated = all.filterNot(t => t.new).toArray();

  // Group them by id
  const byId = updated.reduce((map, item) => map.set(item.id, item), Map());
  return byId.toObject();
};

const getDeletedTools = (state, site, type) => {
  return state.siteCase.tools.deleted
    .get(site, Map())
    .get(type, [])
    .filter(t => !t.new)
    .map(t => t.id);
};

export const serializeTools = (state, site, type) => {
  return {
    new_tools: getNewTools(state, site, type),
    updated_tools: getUpdatedTools(state, site, type),
    deleted_tools: getDeletedTools(state, site, type),
  };
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/tools.js